<template>
  <div class="d-flex flex-grow-1 text-truncate">
    <v-list-item-avatar v-if="image">
      <v-img :src="image"></v-img>
    </v-list-item-avatar>
    <v-list-item-content class="lean-list-item-content" @click="$emit('click')">
      <v-list-item-title v-if="title">
        <lean-list-item-content-part :title="title" />
      </v-list-item-title>
      <v-list-item-subtitle v-if="subtitle">
        <lean-list-item-content-part :title="subtitle" classParms="v-list-item__subtitle" />
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="subtitle2">
        <lean-list-item-content-part :title="subtitle2" classParms="v-list-item__subtitle" />
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <slot name="actions"></slot>
    </v-list-item-action>
  </div>
</template>

<script>
import listItemMixin from '@/mixins/LeanListItem';
import LeanListItemContentPart from './LeanListItemContentPart.vue';

export default {
  name: 'LeanListItemContent',
  mixins: [listItemMixin],
  components: { LeanListItemContentPart }
};
</script>
